import React, { useState } from 'react';

import { Grid, Typography, TextField } from '@mui/material';
import { greyOutEmptyTextField } from '../../Helpers/helpers';

const ICLJupiterChecks = (props) => {
  const handleChange = props.handleChange;

  const [components, set_components] = useState(props.data.components);
  const [probes, set_probes] = useState(props.data.probes);
  const [switches, set_switches] = useState(props.data.switches);
  const [pressure, set_pressure] = useState(props.data.pressure);
  const [WHS, set_WHS] = useState(props.data.WHS);

  const handleElementChange = (val, item) => {
    switch (item) {
      case 'components':
        set_components(val);
        break;
      case 'probes':
        set_probes(val);
        break;
      case 'switches':
        set_switches(val);
        break;
      case 'pressure':
        set_pressure(val);
        break;
      case 'WHS':
        set_WHS(val);
        break;

      default:
        break;
    }
    handleChange(val, item);
  };

  return (
    <Grid
      container
      rowSpacing={0}
      margin={0}
      columnSpacing={{ xs: 0 }}
      rowGap={0}
      style={{ marginLeft: 0, marginRight: 0 }}
    >
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderBottom: 'none',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='left'
        >
          Check electrical components
        </Typography>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderBottom: 'none',
          borderLeft: 'none',
          background: greyOutEmptyTextField(components)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='components'
          value={components}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{ textAlign: 'left', '& fieldset': { border: 'none' } }}
          size='small'
        ></TextField>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderBottom: 'none',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography paddingLeft={1}>Check probes </Typography>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderBottom: 'none',
          borderLeft: 'none',
          background: greyOutEmptyTextField(probes)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='probes'
          value={probes}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{
            textAlign: 'left',
            '& fieldset': { border: 'none', borderBottom: 'none' },
          }}
          size='small'
        ></TextField>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderBottom: 'none',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography paddingLeft={1}>Check LP & HP switch </Typography>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderLeft: 'none',
          borderBottom: 'none',
          background: greyOutEmptyTextField(switches)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='switches'
          value={switches}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          size='small'
          sx={{ textAlign: 'left', '& fieldset': { border: 'none' } }}
        ></TextField>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderBottom: 'none',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography paddingLeft={1}>Check gas pressure</Typography>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderLeft: 'none',
          borderBottom: 'none',
          background: greyOutEmptyTextField(pressure)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='pressure'
          value={pressure}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          size='small'
          sx={{ textAlign: 'left', '& fieldset': { border: 'none' } }}
        ></TextField>
      </Grid>
      <Grid
        sx={{ textAlign: 'left', border: 'solid black 1px' }}
        item
        xs={4}
        md={4}
      >
        <Typography paddingLeft={1}>If WHS check if operating </Typography>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderLeft: 'none',
          background: greyOutEmptyTextField(WHS)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='WHS'
          value={WHS}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          size='small'
          sx={{ textAlign: 'left', '& fieldset': { border: 'none' } }}
        ></TextField>
      </Grid>
    </Grid>
  );
};

export default ICLJupiterChecks;
